import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import VBox from 'components/common/VBox';
import HBox from 'components/common/HBox';
import React from 'react';
import TIME_ZONE_TYPES from 'constants/TIME_ZONE_TYPES';
import WEEK_DAY_COLUMNS from 'constants/WEEK_DAY_COLUMNS';

export default function SimulationInfo(props) {
  const {
    data,
    ...rest
  } = props;
  const {
    recommend_step_cnt = 2000,
    recommend_active_time_list = [],
  } = data || {};

  const tags = React.useMemo(() => {
    const ts = [];
    recommend_active_time_list.forEach(item => {
      const {
        time_zone_tp_cd,
        weekday_tp_cd,
      } = item;
      const timeZone = TIME_ZONE_TYPES[time_zone_tp_cd - 1];
      const weekday = WEEK_DAY_COLUMNS[weekday_tp_cd - 1];
      ts.push(`${weekday} ${timeZone}`);
    });
    return ts;
  }, [recommend_active_time_list]);
  return (
    <VBox {...ex('SimulationInfo', rest)}>
      <HBox>
        <HBox {...ex('SimBox')}>
          <div>
            {T('AI가 예측한 추천 시나리오를 알려드려요')}
          </div>
        </HBox>
        <div>
          <svg width={28} height={28} viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_2725_3168)">
              <path d="M114 58C114 27.0721 88.9279 2 58 2C27.0721 2 2 27.0721 2 58C2 88.9279 27.0721 114 58 114H114V58Z" fill="url(#paint0_linear_2725_3168)" />
            </g>
            <ellipse cx="26.4364" cy="52.9091" rx="6.10909" ry="8.14545" fill="white" />
            <ellipse cx="24.4" cy="52.9089" rx="4.07273" ry="6.10909" fill="black" />
            <ellipse cx="46.8" cy="52.9091" rx="6.10909" ry="8.14545" fill="white" />
            <path d="M28.4727 69.1998C29.1515 70.8968 31.3236 74.2907 34.5818 74.2907C37.84 74.2907 40.6909 69.8786 41.7091 68.1816" stroke="black" strokeWidth={2} strokeLinecap="round" />
            <ellipse cx="44.7636" cy="52.9089" rx="4.07273" ry="6.10909" fill="black" />
            <defs>
              <filter id="filter0_d_2725_3168" x={0} y={0} width={120} height={120} filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                <feOffset dx={2} dy={2} />
                <feGaussianBlur stdDeviation={2} />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" />
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2725_3168" />
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2725_3168" result="shape" />
              </filter>
              <linearGradient id="paint0_linear_2725_3168" x1="21.3455" y1="15.2364" x2="116.036" y2="117.055" gradientUnits="userSpaceOnUse">
                <stop stopColor="#E8F0FF" />
                <stop offset={1} stopColor="#3B6FD1" />
              </linearGradient>
            </defs>
          </svg>
        </div>
      </HBox>
      {!!recommend_step_cnt && (
        <>
          <div {...ex('SimCaption')}>
            {T('활동량')}
          </div>
          <HBox {...ex('SimBox')}>
            <div>
              {T('{0} 보', recommend_step_cnt || 0)}
            </div>
          </HBox>
          <hr />
        </>
      )}
      {!!tags.length && (
        <>
          <div {...ex('SimCaption')}>
            {T('활동시기')}
          </div>
          <HBox {...ex('SimBox')}>
            {tags.map((tag, index) => (
              <div key={tag + index}>
                {tag}
              </div>
            ))}
          </HBox>
        </>
      )}
    </VBox>
  );
}
